import { ErrorHandler, Injectable } from '@angular/core';
import { faro } from '@grafana/faro-web-sdk';

@Injectable()
export class FaroErrorHandler implements ErrorHandler {
  handleError(err: unknown) {
    const error = this.toError(err);

    console.error(error);

    if (faro?.api) {
      faro.api.pushError(error);
    }
  }

  private toError(error: unknown): Error {
    if (error instanceof Error) {
      return error;
    }

    if (typeof error === 'object' && error !== null && 'message' in error) {
      return new Error(String((error as { message: unknown }).message));
    }

    return new Error(String(error));
  }
}
